import ReactDOM from 'react-dom/client';
import './index.css';
import { InitializeApplication } from './Initialize';
import * as secrets from './utils/secrets';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<InitializeApplication stripe={secrets.stripeKey || ""} />);
